import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M96.5 94.33c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M85.88 11.26a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#ACB8C3" d="M6.57 71.88a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#C7D0D9"
      d="m37.84 78.55 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM108.57 24.04H103v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H100v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#7B8493"
      d="M66.99 90.73c-7.25 0-13.14-5.87-13.14-13.08V52.98c0-1.25 1.01-2.26 2.26-2.26s2.26 1.01 2.26 2.26v24.67c0 4.72 3.87 8.57 8.63 8.57s8.63-3.84 8.63-8.57c0-1.25 1.01-2.26 2.26-2.26s2.26 1.01 2.26 2.26c0 7.21-5.9 13.08-13.14 13.08z"
    />
    <path
      fill="#ACB8C3"
      d="M58 18c-22.09 0-40 17.8-40 39.76h25.7c.17-4.22.73-10.69 2.4-18.06C49.03 26.74 58 17.99 58 17.99z"
    />
    <path
      fill="#C7D0D9"
      d="M69.9 39.71C66.97 26.75 58.01 18.01 58 18c0 0-8.96 8.75-11.9 21.71-1.67 7.37-2.23 13.84-2.4 18.06h28.59c-.17-4.22-.73-10.69-2.4-18.06z"
    />
    <path
      fill="#ACB8C3"
      d="M58 18s8.96 8.75 11.9 21.71c1.67 7.37 2.23 13.84 2.4 18.06H98c0-21.96-17.91-39.76-40-39.76z"
    />
  </svg>
);
const SvgEnrichedIconRiskInsuranceGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconRiskInsuranceGreyscale);
export default Memo;
